import { Agent } from '@propertypal/shared/src/types/agents';
import useCallAgent from '@propertypal/web-app/src/utils/useCallAgent';
import React, { CSSProperties, FunctionComponent } from 'react';
import Button from '../buttons/Button';
import { CallAgentBox, ShowNumberBox } from './ContactAgent.style';

interface Props {
  containerStyle?: CSSProperties;
  agent: Agent;
  page: string;
  location: string;
  icon?: any;
}

const ContactAgent: FunctionComponent<Props> = (props) => {
  const { callAgent, modal, showPhoneModal } = useCallAgent();

  const handleShowPhoneClick = () => {
    showPhoneModal(undefined, undefined, props.agent, props.page, props.location);
  };

  const handleCallAgentClick = () => {
    callAgent(undefined, undefined, props.agent, props.page, props.location);
  };

  return (
    <div style={props.containerStyle}>
      {modal}
      <ShowNumberBox>
        <Button icon={props.icon} onClick={handleShowPhoneClick} testID="showPhoneNumberButton">
          Call the Agent
        </Button>
      </ShowNumberBox>

      <CallAgentBox>
        <Button icon={props.icon} onClick={handleCallAgentClick} type="button" testID="callAgent">
          Call the Agent
        </Button>
      </CallAgentBox>
    </div>
  );
};

export default ContactAgent;
